// Added by Sejune Oh on 2019-03-14
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { action, makeObservable, observable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Root store
import Rootstore from '../index'

// Store
import RegistryStoreBase from '../base/RegistryStoreBase'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface RegistryBaseProps {
  version?: string
  token?: string
  endpoint?: string
  node_key?: string
  name?: string
  additional_data?: string
  connected_at?: string
  server_weight?: number
  web_socket_endpoint?: string
}

export interface RegistryProps extends RegistryBaseProps {
  id?: string
  connected_at_str?: string
  discnt_btn?: JSX.Element
  reason?: string
  node_name?: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class RegistryStore extends RegistryStoreBase<RegistryProps> {
  totalCount: number = 0
  cntServerMap: Map<string, string> = new Map()

  root?: Rootstore

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(root: Rootstore) {
    super({ storeName: 'RegistryStore', apiUrl: 'registry/connected-servers', _root: root })
    this.root = root
    makeObservable(this, {
      totalCount: observable,
      cntServerMap: observable,
      _setTotalCount: action,
      setCntServerMap: action,
    })
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getCntServer = async (token: string) => {
    return await super.getFullResponse(token)
  }

  getCntAppServers = async () => {
    const rtnData = await super.getAll('app_session_only', 'true')
    return rtnData.items as Array<RegistryProps>
  }

  stopCntAppServer = async (token: string, reason: string) => {
    return await super.update(
      token,
      {
        token,
        reason,
      },
      '/stop'
    )
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  _setTotalCount = (count: number) => {
    this.totalCount = count
  }

  setCntServerMap = (cntServerList: Array<RegistryProps>) => {
    cntServerList.forEach(({ token, endpoint }) => {
      this.cntServerMap.set(token!, endpoint!)
    })
  }

  getCntServerEndpoint = (token: string) => {
    return this.cntServerMap.get(token) || 'NOT CONNECTED'
  }
}
